import {dataTestId} from '@hconnect/uikit'
import {HPToggleButton} from '@hconnect/uikit/src/lib2'
import {useMediaQuery, useTheme} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {DayPeriod} from '../types'

interface StrengthTargetTabsProps {
  selectedTab: DayPeriod | 'overview'
  onTabChange: (tab: DayPeriod | 'overview') => void
}

const TAB_VALUES: (DayPeriod | 'overview')[] = ['overview', 1, 2, 3, 7, 28]

export const StrengthTargetTabs: React.FC<StrengthTargetTabsProps> = ({
  selectedTab,
  onTabChange
}) => {
  const {t} = useTranslation()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const getTabLabel = (period: DayPeriod | 'overview'): string => {
    if (period === 'overview') {
      return isMobile
        ? t('materialsSettings.strengthTargets.overviewShort')
        : t('materialsSettings.strengthTargets.overview')
    }
    return isMobile
      ? `${period}D`
      : t('materialsSettings.strengthTargets.dayPeriod', {count: period})
  }

  return (
    <HPToggleButton
      value={String(selectedTab)}
      onChange={(value) => {
        const parsed = value === 'overview' ? 'overview' : (Number(value) as DayPeriod)
        onTabChange(parsed)
      }}
      backgroundMode="light"
      color="primary"
      options={TAB_VALUES.map((period) => ({
        value: String(period),
        title: getTabLabel(period),
        dataTestId: `strength_target_tab_${period}`
      }))}
      {...dataTestId('strength_target_tabs')}
    />
  )
}
